import { call, put, delay} from "redux-saga/effects";
import { signIn, getIdToken ,getUserInformation, createUserProfileDocument, sendVerificationEmail,  sendResetPasswordEmail,} from "../../firebase/auth";
import { toast } from "react-toastify";
import axiosInstance from "../../utilities/axios-instance";
import {login_success,logout_success,register} from "../actions";
import { show_loader, hide_loader } from "../actions";
import { browserHistory } from 'react-router'

// import {updateProfile} from "../firebase/methods";
// import { setCookies } from '../utilities/auth-helpers';
// import cookie from "js-cookie";
// import { setProductUrlCookie } from "../utilities/auth-helpers";


export function* logout({ payload }) { 
  yield put(logout_success());  
  // yield put(push("/")); 
}
export function* login({ payload: {values: { email, password },history:history, callback, },}) {
  try {
    // alert(JSON.stringify(history))
     yield put(show_loader());
    const response = yield call(signIn, { email, password });
    var user = response.user;
    // alert(JSON.stringify(response.user.email))
    console.log(response.user)
    if (!user) throw new Error("Error while log in.");
    const userData = yield call(getUserInformation, { email }); 
var information;
 userData.forEach(doc => {
  // alert(JSON.stringify(doc.data()))
  // console.log(doc.id, '=>', doc.data());
  information=doc.data();

});


// alert(process.env.REACT_APP_SERVER_URL)
    var token = yield call(getIdToken, user);
    let data = {
      method:"POST",
      url: "/validate-admin",
      headers: { "X-Authorization": `Bearer ${token}` },
      data:{"info":information},

    };
    yield call(axiosInstance, data);
    // alert(JSON.stringify(user));
    yield put(login_success(user));
    // yield put(hide_loader());
    yield delay(100) 
    var url='/dashboard';
    var newurl="http://localhost:3000"+url;
    // window.location = newurl;
    // yield put(push('/dashboard'));
    history.push('/dashboard')

    toast.success("Logged in successfully.");
  } catch (error) {
    // yield put(hideLoader())
    if (callback) callback();
    toast.error(error.message);
  }
}











export function* registered_proceed(payload) {
  try{
    //   yield put(showLoader());
      yield call(createUserProfileDocument,payload.payload.user,payload.payload.data);
      yield call(sendVerificationEmail,payload.payload.user)
      yield put(register(payload.payload));
      toast.success("User successfully Registered.");
      payload.payload.history.push('/login');
    //   yield delay(100) 
    // var url='/login';
    // var newurl="http://localhost:3000"+url;
    // window.location = newurl;

   
  }catch(error){
    //  yield put(registerFailure(error));
    alert("No")
     toast.error(error.message);
    //  yield put(hideLoader());
  }
  
}




  export function* forgotPasswordHandler(details)
   {
       alert(JSON.stringify(details.payload.values.email));

    try{
    //   yield put(showLoader());
      yield call(sendResetPasswordEmail,details.payload.values.email);
    //   yield put(forgotPasswordSuccess(true));
      alert('send');
    //   yield put(hideLoader());
      toast.success("Password reset email hase been sent!");
    //   Router.push('/mail-sent');
    }catch(error){
    //   yield put(forgotPasswordFailure(error));
    alert('False')
    console.log(error.message)
    //   toast.error(error.message);
    //   yield put(hideLoader());
    }
  }
  
//   export function* updateProfileHandler({payload:{data}}) {
//     yield put(updateProfileRequested());
//     try{
//       yield put(showLoader());
//       yield call(updateProfile, data);
//       yield put(updateProfileSuccess(true));
//       yield put(hideLoader());
//       toast.success("Profile successfully updated!");
//     }catch(error){
//       yield put(updateProfileFailure(error));
//       toast.error(error.message);
//       yield put(hideLoader());
//     }
//   }





// function* User() {
//   yield all([takeLatest(logout, saga_logout),
//     takeLatest(login, saga_login),
//     // takeLatest(UPDATE_USER, UpdateUser)
//   ]);
// }

// export default User;
